import { Component, OnInit,  ElementRef, ViewChild  } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { CommonService } from 'src/app/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';

declare const bootstrap: any;

@Component({
  selector: 'app-user-guide-configuration',
  templateUrl: './user-guide-configuration.component.html',
  styleUrls: ['./user-guide-configuration.component.css']
})
export class UserGuideConfigurationComponent extends BaseComponent implements OnInit {
  @ViewChild('coursesModal') modalRef!: ElementRef; isView: boolean = false;
  table: any[] = []; editData: any = ''; isEdit: boolean = false;
  menuId: any = 0;
  subMenuId: any = 0;
  screenId: any = 0;
  htmlContentWithOutHtml = '';
  menuList: Array<any> = [];
  subMenuList: Array<any> = [];
  screensList: Array<any> = [];
  htmlContent = '';
  languageId: any = 1;
  languageList: any = [{id: 1, name: 'English'}]
  showHtml() {
    this.htmlContentWithOutHtml = document.getElementById('htmldiv')?.innerHTML;
  }

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['bold']
    ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };

  constructor(CommonService: CommonService, toastr: ToastrService, private route: Router, private active: ActivatedRoute,) {
    super(CommonService, toastr);

  }

  ngOnInit(): void {
    this.GridList();
    this.GetMenuList();
  }

  GetMenuList() { // TaskManager/LoadModules
    this.menuList = [];
    this.activeSpinner();
    this.CommonService.postCall('TaskManager/LoadModules', {}).subscribe((res: any) => {
      this.menuList = res;
      this.deactivateSpinner();
    }, e => {
      this.deactivateSpinner();

    })
  }

  GridList() { // UserGuideMapping/GetAllUserGuideMapping
    this.table = [];
    this.activeSpinner();
    this.CommonService.postCall('UserGuideMapping/GetAllUserGuideMapping', {}).subscribe((res: any) => {
      if(res?.status) {
        this.table = res?.data;
      }
      this.CommonService.deactivateSpinner();
    }, e => {
      this.CommonService.deactivateSpinner();

    })
  }

  GetSubMenuList(evnt: any) { // TaskManager/LoadModules
    if(evnt != undefined) {
      const encoded = localStorage.getItem('RoleId'); // "NA=="
      const decoded = atob(encoded!); 
      this.subMenuList = [];
      this.activeSpinner();
      this.CommonService.getCall(`TaskManager/LoadWorkItemsByModule/${evnt}`).subscribe((res: any) => {
        this.subMenuList = res ?? [];
        this.deactivateSpinner();
      }, e => {
        this.deactivateSpinner();
      })
    }
  }

  GetScreenList(evnt: any) { // TaskManager/LoadModules
    if(evnt != undefined) {
      this.screensList = [];
      this.activeSpinner();
      this.CommonService.getCall(`TaskManager/LoadWorkItemsByModule/${evnt}`).subscribe((res: any) => {
        this.screensList = res ?? [];
        this.deactivateSpinner();
      }, e => {
        this.deactivateSpinner();
      })
    }
  }

  save() {
    if (this.menuId == 0 || this.menuId == "" || this.menuId == undefined) {
      return this.toastr.warning("Please select Menu");
    } else {
      this.activeSpinner();
      let payload = {
        "ID": this.isEdit ? this.editData?.ID : 0,
        "MENU_ID": this.menuId !=0 && this.menuId != null ? this.menuId : 0,
        "SUB_MENU_ID": this.subMenuId !=0 && this.subMenuId != null ? this.subMenuId: 0,
        "SCREEN_ID": this.screenId !=0 && this.screenId != null ? this.screenId: 0,
        "TENANTCODE": this.TenantCode,
        "IS_ACTIVE": true,
        "CREATED_BY": this.userId,
        "MODIFIED_BY": this.userId,
        "HTML_CONTENT": this.htmlContent,
        "LANGUAGE_ID": this.languageId
       
      };
        this.CommonService.postCall( "UserGuideMapping/SaveOrUpdateUserGuideMapping", payload).subscribe(
          (res: any) => {
            if(res?.status) {
              this.toastr.success(res.message),
              this.CommonService.deactivateSpinner();
              setTimeout(() => {
                document.getElementById('md_close')?.click();
                this.Clear();
                this.GridList();
              }, 500);
            } else {
              this.toastr.info(res.message),
              this.CommonService.deactivateSpinner();
            }
          },
          (e) => {
            this.toastr.error(e.error.message);
            this.CommonService.deactivateSpinner();
          }
        );
      }
  }

  GetById(evnt: any, ctrl = '') {
    this.activeSpinner();
    this.CommonService.postCall('UserGuideMapping/GetByIdUserGuideMapping', { ID: evnt?.ID}).subscribe((res: any) => {
      if(res?.status) {
        this.isEdit = true;
        if(ctrl == 'view') {
          this.isView = true;
        }
        this.editData = res?.data;
        this.menuId= this.editData?.MENU_ID,
        this.subMenuId= this.editData?.SUB_MENU_ID,
        this.screenId= this.editData?.SCREEN_ID,
        this.TenantCode= this.editData?.TENANTCODE,
        this.htmlContent= this.editData?.HTML_CONTENT,
        this.languageId= this.editData?.LANGUAGE_ID
        this.GetSubMenuList(this.editData?.MENU_ID)
        this.GetScreenList(this.editData?.subMenuId)
      }
      this.CommonService.deactivateSpinner();
    }, e => {
      this.CommonService.deactivateSpinner();

    })
  }

  Clear() {
    this.editData = '',
    this.menuId = '',
    this.subMenuId = '',
    this.screenId = '',
    this.htmlContent = '',
    this.languageId = 1;
    this.isView = false;
    this.isEdit = false;
  }

  closeModal() {
    const el = this.modalRef?.nativeElement;
    const inst = bootstrap.Modal.getInstance(el) ?? new bootstrap.Modal(el);
    inst.hide();
    this.Clear();
  }
  
}
